import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import { default as DialogMUI } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const Dialog = ({ title, message, open, setOpen, onHandleOk }: any) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <DialogMUI
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogText id='alert-dialog-description'>{message}</DialogText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={onHandleOk} autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </DialogMUI>
    </div>
  );
};

export default Dialog;

const DialogText = styled(DialogContentText)`
  color: ${({ theme }) => theme.palette.text.primary};
`;
